export default __webpack_public_path__ + "static/media/scw-grid-6.bff5b79e.svg";